/* e-Lumii Animations v3.6 — METEORS FULL WIDTH */
(function(){
"use strict";

function initAurora(){
  var hero=document.querySelector('[id*="lumii-hero"]');
  if(!hero)return;
  hero.style.position='relative';
  hero.style.overflow='hidden';
  var container=document.querySelector('.aurora-particles');
  if(!container){container=document.createElement('div');container.className='aurora-particles';}
  hero.appendChild(container);
  container.style.cssText='display:block!important;position:absolute;top:0;left:0;right:0;bottom:0;z-index:2;pointer-events:none;overflow:hidden;';
  container.innerHTML='';
  var isMobile=window.innerWidth<750;
  var count=isMobile?20:40;
  var colors=['rgba(255,105,180,','rgba(255,20,147,','rgba(255,182,193,','rgba(200,100,255,','rgba(255,255,255,'];
  var anims=['auroraFloat','auroraDrift','auroraRise','auroraSway'];
  for(var i=0;i<count;i++){
    var p=document.createElement('div');
    p.className='aurora-particle';
    p.textContent='\u00AD';
    var size=isMobile?(3+Math.random()*6):(4+Math.random()*10);
    var color=colors[Math.floor(Math.random()*colors.length)];
    var opacity=0.3+Math.random()*0.7;
    var anim=anims[Math.floor(Math.random()*anims.length)];
    var dur=6+Math.random()*14;
    var delay=Math.random()*10;
    var glow=Math.random()>0.5?('0 0 '+(size*2)+'px '+color+'0.5), 0 0 '+(size*4)+'px '+color+'0.3)'):'none';
    p.style.cssText='display:block!important;position:absolute;border-radius:50%;pointer-events:none;'+
      'width:'+size+'px;height:'+size+'px;'+
      'background:'+color+opacity+');'+
      'left:'+Math.random()*100+'%;top:'+Math.random()*100+'%;'+
      'animation:'+anim+' '+dur+'s ease-in-out '+delay+'s infinite;'+
      'box-shadow:'+glow+';';
    container.appendChild(p);
  }
}

function initMeteors(){
  var section=document.querySelector('.meteors-section');
  if(!section)return;
  section.style.position='relative';
  section.style.overflow='hidden';
  section.querySelectorAll('.meteor-trail').forEach(function(m){m.remove();});
  var isMobile=window.innerWidth<750;
  var count=isMobile?12:28;
  for(var i=0;i<count;i++){
    var m=document.createElement('div');
    var rng=Math.random();
    if(rng<0.2){
      m.className='meteor-trail meteor-trail--large';
    }else if(rng<0.38){
      m.className='meteor-trail meteor-trail--flash';
    }else{
      m.className='meteor-trail';
    }
    m.textContent='\u00AD';
    var dur=2+Math.random()*4;
    var delay=Math.random()*8;
    var top=-5+Math.random()*70;
    var left=20+Math.random()*80;
    m.style.cssText='display:block!important;position:absolute;'+
      'top:'+top+'%;left:'+left+'%;'+
      'animation-duration:'+dur+'s;'+
      'animation-delay:'+delay+'s;';
    section.appendChild(m);
  }
}

function initScrollReveal(){
  var sections=document.querySelectorAll('.shopify-section');
  sections.forEach(function(s){
    if(s.id&&s.id.indexOf('lumii-hero')!==-1)return;
    s.classList.add('scroll-reveal');
  });
  function checkReveal(){
    document.querySelectorAll('.scroll-reveal:not(.revealed)').forEach(function(el){
      if(el.getBoundingClientRect().top<window.innerHeight*0.88){
        el.classList.add('revealed');
      }
    });
  }
  window.addEventListener('scroll',checkReveal,{passive:true});
  checkReveal();
}

function init(){
  initAurora();
  initMeteors();
  initScrollReveal();
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
}else{
  init();
}
})();